


























import { Component, Prop, Inject, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { drag, DragPosition } from '../drag-dir';
import SwTable from './sw-table.vue'; // only for types
import {
  TableHeaderMetrics,
  ColumnResizerTrigger,
} from './types';
import { CSSStyleOptions } from '../common-types';

const cssPrefix = 'sw-table-col-resizer';

@Component({
  components: {},
  directives: { drag },
})
export default class SwTableColResizer extends SwExtendedVue {
  @Prop({ type: Object, required: true })
  headerMetrics: TableHeaderMetrics;

  @Prop({ type: Object, required: true })
  headerProps: SwTable['headerProps'];

  @Prop({ validator(value) { return value instanceof Object || value === null; }, required: true })
  trigger: ColumnResizerTrigger | null;

  cssPrefix = cssPrefix;

  position: { left: number, top: number } = {
    left: 0,
    top: 0,
  };
  isResizing: boolean = false;
  cachedOffsetParentRect: ClientRect | null = null;

  get resizerStyle(): CSSStyleOptions {
    return {
      height: `${(this.trigger ? this.trigger.colRect.height : 0) + this.headerProps.bodyMetrics.clientHeight!}px`,
    };
  }

  get posStyle(): CSSStyleOptions {
    if (!this.position) { return {}; }
    return {
      left: `${this.position.left}px`,
      top: `${this.position.top}px`,
    };
  }

  @Inject()
  claimColResizerDone: SwTable['claimColResizerDone'];

  @Inject()
  claimColResizerTriggerLock: SwTable['claimColResizerTriggerLock'];

  @Watch('trigger')
  updatePosition() {
    if (this.trigger) {
      const el = this.$el as HTMLElement;
      if (!el.offsetParent) { return; }
      const opRect = el.offsetParent.getBoundingClientRect();
      this.position = {
        left: this.trigger.rect.left - opRect.left,
        top: this.trigger.rect.top - opRect.top - 1/* offset the top border */,
      };
    }
  }

  onMouseEnter() {
    this.claimColResizerTriggerLock(true);
  }

  onMouseLeave() {
    if (this.isResizing) { return; }
    this.claimColResizerDone(0, false);
  }

  positioning(toClientPos: DragPosition) {
    this.position.left = toClientPos.x - this.cachedOffsetParentRect!.left;
  }

  done() {
    const opRect = this.cachedOffsetParentRect;
    const origWidth = this.trigger ? this.trigger.colRect.width : -1;
    const initLeft = this.trigger && opRect ? (this.trigger.rect.left - opRect.left) : this.position.left;
    const offset = this.position.left - initLeft;

    this.isResizing = false;
    this.cachedOffsetParentRect = null;
    if (offset !== 0 && origWidth >= 0) {
      this.claimColResizerDone(Math.max(offset + origWidth, 5), true);
    }
  }

  start() {
    this.isResizing = true;
    this.cachedOffsetParentRect = (this.$el as HTMLElement).offsetParent!.getBoundingClientRect();
  }

  mounted() {
    this.updatePosition();
  }
}
